import styled from 'styled-components';

export const TopBarDropdownSupportStyle = {
  Container: styled.div`
    margin-left: 8px;
    max-width: fit-content;
  `,
};
